<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title" [ngStyle]="{
        'font-weight': 'bold',
        color: 'red',
        'text-align': 'center',
        'padding-left': decleration?.declaration?.id == '5' ? '30px' : '250px'
      }">
      {{ declerationName }}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal('cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="openDeclerationStatus == false">
      <span style="font-weight: bold; padding: 15px; padding-top: 5px">Please go through all the clients and answer the
        independece question
        by clicking decleration button(It will be enable when you will be on
        last page of client list)</span>
    </div>
    <div *ngIf="openDeclerationStatus == false">
      <table style="width: 100%">
        <tr style="background-color: #17a2b8">
          <th style="width: 5%">Sr No</th>
          <th style="width: 45%">Name</th>
          <th style="width: 10%">Branch</th>
          <th style="width: 30%">Legal Status</th>
          <th style="width: 10%">Active</th>
        </tr>
        <tr *ngFor="
            let client of allClientList
              | slice: (page - 1) * pageSize:(page - 1) * pageSize + pageSize;
            let i = index
          ">
          <td style="text-align: center">
            <span>{{ i + 1 }}</span>
          </td>
          <td>
            <span>{{ client.name }}</span>
          </td>
          <td>
            <span>{{ client.branch.name }}</span>
          </td>
          <td>
            <span>{{ client.legalStatus.name }}</span>
          </td>
          <td>
            <span>{{ client.ediaryStatus.name }}</span>
          </td>
        </tr>
      </table>
      <div class="row" style="padding-top: 10px">
        <div class="col-sm-6">
          <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="allClientList.length" [maxSize]="5"
            (pageChange)="onPageChange()" [boundaryLinks]="true"></ngb-pagination>
          <!-- <ngb-pagination [collectionSize]="allClientList.length" [(page)]="page"    [maxSize]="3" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"> -->
          <!-- </ngb-pagination> -->
        </div>
        <div class="col-sm-6" *ngIf="enableDecleration">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="openDecleration()">
            Declaration
          </button>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-9 col-form-label"></div>
        <div class="col-sm-3 col-form-label">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="closeModal('cross click')">
            Close
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="openDeclerationStatus">
      <div *ngIf="clientDeclerationObj != null">
        <div *ngIf="decleration.declaration.id == '3'">
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Name of the Client :
            </div>
            <div class="col-form-label" style="color: red">
              {{ clientDeclerationObj.client.name }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Legal Status :
            </div>
            <div class="col-form-label" style="color: red">
              {{ clientDeclerationObj.client.legalStatus.name }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Client Added On :
            </div>
            <div class="col-form-label" style="color: red">
              {{
              clientDeclerationObj.client.createdDate
              | date: "dd-MMM-yyyy h:mm a"
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Assignments :
            </div>
            <div class="col-form-label" style="color: red">
              <span *ngFor="
                  let assignment of clientDeclerationObj.client
                    .clientAssignment;
                  let i2 = index;
                  let first = first;
                  let last = last
                ">
                {{ assignment.name }}
                <span *ngIf="
                    i2 < clientDeclerationObj.client.clientAssignment.length &&
                    !last
                  ">
                  ,
                </span>
                <span *ngIf="last"> . </span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Partner Assigned :
            </div>
            <div class="col-form-label" style="color: red" *ngFor="
                let partner of partnerAssignedArray;
                let i3 = index;
                let first = first;
                let last = last
              ">
              {{ partner.name }}
              <span *ngIf="i3 < partnerAssignedArray.length && !last"> , </span>
              <span *ngIf="last"> . </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-form-label" style="font-weight: bold">
              Branch :
            </div>
            <div class="col-form-label" style="color: red">
              {{ clientDeclerationObj.client.branch.name }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="decleration.declaration.id != 3">
        <div class="row" style="padding-left: 15px;">
          <div class="col-sm-3 col-form-label" style="font-weight: bold">
            Name:
          </div>
          <div class="col-form-label" style="color: red">
            {{ userDetailsObj.firstName }} {{ userDetailsObj.middleName }}
            {{ userDetailsObj.lastName }}
          </div>
        </div>
        <div class="row" style="padding-left: 15px;" *ngIf="userDetailsObj.designation == null">
          <div class="col-sm-3 col-form-label" style="font-weight: bold">
            Designation:
          </div>
          <div class="col-form-label" style="color: red">
            {{ userDetailsObj.type }}
          </div>
        </div>

        <div class="row" style="padding-left: 15px;" *ngIf="userDetailsObj.designation != null">
          <div class="col-sm-3 col-form-label" style="font-weight: bold">
            Designation:
          </div>
          <div class="col-form-label" style="color: red">
            {{ userDetailsObj.designation.name }}
          </div>
        </div>
        <div class="row" style="padding-left: 15px;">
          <div class="col-sm-3 col-form-label" style="font-weight: bold">
            Date of joining :
          </div>
          <div class="col-form-label" style="color: red">
            {{
            userDetailsObj.userOfficialDetails.joiningDate
            | date: "dd-MMM-yyyy"
            }}
          </div>
        </div>
        <div class="row" style="padding-left: 15px;">
          <div class="col-sm-3 col-form-label" style="font-weight: bold">
            Branch :
          </div>
          <div class="col-form-label" style="color: red">
            {{ userDetailsObj.userOfficialDetails.branch.name }}
          </div>
        </div>
      </div>

      <div class="row pt-5" style="padding-left: 15px;">
        <!-- <div class="col-sm-3 col-form-label" style="font-weight: bold">
          {{ this.decleration.declaration.id == '5' ? 'Definition of Personnel' : 'Detail Declaration' }} :
        </div> -->
        <div class="col-sm-12 col-form-label " style="white-space: pre-line;"
          [innerHTML]="declerationObj.beginText?.split('\\n').join('\n')">
          <!-- {{ declerationObj.beginText?.split('\\n').join('\n') }} -->
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-sm-1" style="
            border: 1px solid;
            font-weight: bold;
            padding: inherit;
            padding-left: 8px;
          ">
          Sr No.
        </div>
        <div class="col-sm-10" style="border: 1px solid; font-weight: bold; text-align: center">
          Declaration
        </div>
        <div class="col-sm-1" style="border: 1px solid; font-weight: bold; padding: inherit">
          Agree / Disagree
        </div>
      </div>

      <app-independence-question *ngFor="
          let question of data.userDeclrationAnswers;
          let questionIndex = index
        " [element]="{
          index: questionIndex,
          question: question.declarationQuestion.question,
          id: question.declarationQuestion.id
        }" (agreeChanged)="onAgreeChanged($event)">
      </app-independence-question>

      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-8 col-form-label" style="font-weight: bold">
          Explanation in cases where 'disagree' responses are given
        </div>
      </div>
      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-10 col-form-label">
          <textarea rows="2" [(ngModel)]="explanation" cols="70" [disabled]="disabledExpliantion"></textarea>
        </div>
      </div>

      <div class="row" *ngIf="declerationObj.endText && decleration.declaration.id != 5">
        <div class="col-sm-8 col-form-label" style="font-weight: bold">
          Representation
        </div>
      </div>
      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-12 col-form-label" style="white-space: pre-line;"
          [innerHTML]="declerationObj.endText?.split('\\n').join('\n')">
          <!-- {{ declerationObj.endText }} -->
        </div>
      </div>

      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-2 col-form-label" style="font-weight: bold">
          Sign :
        </div>
        <div class="col-sm-4 col-form-label" style="font-weight: bold">
          <input type="checkbox" (click)="onSigned()" value="false" />
        </div>
      </div>

      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-2 col-form-label" style="font-weight: bold">
          Name:
        </div>
        <div class="col-sm-6 col-form-label" style="font-weight: bold">
          {{ userDetailsObj.firstName }} {{ userDetailsObj.middleName }}
          {{ userDetailsObj.lastName }}
        </div>
      </div>

      <div class="row" style="padding-left: 15px;" *ngIf="userDetailsObj.designation == null">
        <div class="col-sm-2 col-form-label" style="font-weight: bold">
          Designation:
        </div>
        <div class="col-sm-6 col-form-label" style="font-weight: bold">
          {{ userDetailsObj.type }}
        </div>
      </div>

      <div class="row" style="padding-left: 15px;" *ngIf="userDetailsObj.designation != null">
        <div class="col-sm-2 col-form-label" style="font-weight: bold">
          Designation:
        </div>
        <div class="col-sm-6 col-form-label" style="font-weight: bold">
          {{ userDetailsObj.designation.name }}
        </div>
      </div>

      <div class="row" style="padding-left: 15px;">
        <div class="col-sm-2 col-form-label" style="font-weight: bold">
          Date:
        </div>
        <div class="col-sm-6 col-form-label" style="font-weight: bold">
          {{ todaysDate | date: "dd-MMM-yyyy h:mm a" }}
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-3 col-form-label"></div>
        <div class="col-sm-3 col-form-label">
          <button type="button" *ngIf="
              decleration.declaration.id == '1' ||
              decleration.declaration.id == '2'
            " class="btn btn-sm btn-block btn-outline-theme" (click)="onClientListClick()">
            Client List
          </button>
        </div>
        <div class="col-sm-3 col-form-label">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="closeModal('cross click')">
            Close
          </button>
        </div>
        <div class="col-sm-3 col-form-label">
          <button type="button" *ngIf="openDeclerationStatus" class="btn btn-sm btn-block btn-outline-theme"
            (click)="onSaveDecleration()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>